var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { Entity } from '@decahedron/entity';
import env from 'config/env';
var TargetRepository = /** @class */ (function (_super) {
    __extends(TargetRepository, _super);
    function TargetRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.entity = Entity;
        _this.url = 'api/v2/target';
        _this.baseUrl = env.JOBILLA_API_ROOT;
        return _this;
    }
    TargetRepository.prototype.getWidgetUrl = function (jobId) {
        var _this = this;
        return this.get(this.url + "/url/job/" + jobId)
            .then(function (response) { return _this.responseTransformer(response).data.url; });
    };
    return TargetRepository;
}(AbstractRepository));
export { TargetRepository };
